<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="showace">Show Ace:</label>
      
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              name="showace"
              v-model="form.showace"
            />
         
        </div>

        <div class="col-md-4 mb-3 d-flex align-items-center">
          <label class="form-check-label" for="showacepoints"
            >Show Ace Points:</label
          >
      
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              name="showacepoints"
              v-model="form.showacepoints"
            />
      
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="aceheadercolor"
              >Ace header color:</label
            >
            <b-select
              name="aceheadercolor"
              class="form-select"
              v-model="form.aceheadercolor"
            >
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option
              ><option value="Yellow" style="color: Yellow">Yellow </option
              ><option value="grey" style="color: grey">grey </option
              ><option value="blue" style="color: blue">blue </option
              ><option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="aceheaderfontcolor"
              >Ace header font color:</label
            >
            <b-select
              name="aceheaderfontcolor"
              class="form-select"
              v-model="form.aceheaderfontcolor"
            >
              <option value="White" style="color: black">White</option>
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option
              ><option value="Yellow" style="color: Yellow">Yellow </option
              ><option value="grey" style="color: grey">grey </option
              ><option value="blue" style="color: blue">blue </option
              ><option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="acebuttoncolor"
              >Ace button color:</label
            >
            <b-select
              name="acebuttoncolor"
              class="form-select"
              v-model="form.acebuttoncolor"
            >
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option>
              <option value="Yellow" style="color: Yellow">Yellow </option>
              <option value="grey" style="color: grey">grey </option>
              <option value="blue" style="color: blue">blue </option>
              <option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>

        <div class="col-md-4 mt-3">
          <div class="form-group">
            <label class="form-label" for="acebuttonfontcolor"
              >Ace button font color:</label
            >
            <b-select
              name="acebuttonfontcolor"
              class="form-select"
              v-model="form.acebuttonfontcolor"
            >
              <option value="White" style="color: black">White</option>
              <option value="Orange" style="color: Orange">Orange</option>
              <option value="Brown" style="color: Brown">Brown </option
              ><option value="Yellow" style="color: Yellow">Yellow </option
              ><option value="grey" style="color: grey">grey </option
              ><option value="blue" style="color: blue">blue </option
              ><option value="red" style="color: red">red</option>
            </b-select>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "AceModule",
  data() {
    return {};
  },
  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
};
</script>
<style></style>
